import React, { useState } from "react";
import { Navigate, useNavigate, redirect } from "react-router-dom";
import {
  CalendarOutlined,
  TeamOutlined,
  FolderOpenOutlined,
  MedicineBoxOutlined,
  BuildOutlined,
  MedicineBoxTwoTone,
  CloseOutlined,
  SyncOutlined,
} from "@ant-design/icons";
import { Breadcrumb, Layout, Menu, theme, Image } from "antd";
import { confApp } from "../CONF_APP";

const { Header, Content, Footer, Sider } = Layout;
function getItem(label, key, icon, children) {
  return {
    key,
    icon,
    children,
    label,
  };
}
const items = [
  getItem("Catalogos", "sub1", <FolderOpenOutlined />, [
    getItem("Médicos", "1"),
    getItem("Enfermeras", "2"),
    getItem("Técnicos", "3"),
    getItem("Clasif. Filtros", "4"),
    getItem("Filtros", "5"),
    getItem("Horarios", "13"),
  ]),
  getItem("Citas", "6", <CalendarOutlined />),
  getItem("Pacientes", "7", <TeamOutlined />),
  getItem("Asignación de Filtro", "7.1", <SyncOutlined />),
  getItem("Hemodíalisis", "8", <MedicineBoxTwoTone />, [
    getItem("Lista de asistencia", "8.1"),
    getItem("Nota Médica", "8.2"),
    getItem("Hoja de Enfermería", "8.3"),
  ]),
  getItem("Procesos Técnicos", "sub2", <BuildOutlined />, [
    getItem("Bitacora de Filtros", "9"),
    getItem("Cebado", "10"),
  ]),
  getItem("Consulta", "11", <MedicineBoxOutlined />),
  getItem("Salir", "12", <CloseOutlined />),
];

export const LayoutHome = ({ children, title, selectedKey }) => {
  const [collapsed, setCollapsed] = useState(false);
  const nombreUser = JSON.parse(localStorage.getItem("auth")).nombre;

  const deleteCookies = () => {
    document.cookie = `sessionID=;`;
    document.cookie = "expira=;";
  };

  const cerrarSesion = () => {
    deleteCookies();
    const auth = {
      id: 0,
      idUser: "",
      nombre: "",
      sesionIni: undefined,
    };

    localStorage.setItem("auth", JSON.stringify(auth));
    window.location = `/#/App`;
  };

  const onClick = (e) => {
    switch (e.key) {
      case "Cerrar":
        // AQUI VA METODO PARA CERRAR SESIÓN
        window.location.pathname = "/";
        break;
      case "6":
        window.location.replace("/#/App/Home/Citas");
        break;
      case "7":
        window.location.replace("/#/App/Home/Pacientes");
        break;
      case "13":
        window.location.replace("/#/App/Home/Horarios");
        break;
      case "11":
        window.location.replace("/#/App/Home/Consulta");
        break;
      case "12":
        cerrarSesion();
        break;
      default:
        break;
    }
  };

  const {
    token: { colorBgContainer, borderRadiusLG },
  } = theme.useToken();

  return (
    <Layout style={{ minHeight: "100vh" }}>
      <Sider
        collapsible
        collapsed={collapsed}
        onCollapse={(value) => setCollapsed(value)}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Image
            src="/Images/Logo.png"
            width={100}
            style={{ padding: "10px" }}
          />
        </div>
        <div className="demo-logo-vertical" />
        <Menu
          theme="dark"
          selectedKeys={[selectedKey]}
          mode="inline"
          items={items}
          onClick={onClick}
        />
      </Sider>
      <Layout>
        <Content style={{ margin: "0 16px" }}>
          <Breadcrumb
            style={{ margin: "16px 0" }}
            items={[
              {
                title: (
                  <a href="/#/App/Home" style={{ textDecoration: "none" }}>
                    Menú
                  </a>
                ),
              },
              { title: title },
            ]}
          />
          <div
            style={{
              padding: 24,
              minHeight: 360,
              background: colorBgContainer,
              borderRadius: borderRadiusLG,
            }}
          >
            {children}
          </div>
        </Content>
        <Footer style={{ textAlign: "center" }}>
          © Todos los derechos GRUPO RADYXXA México {new Date().getFullYear()} - Versión {confApp.VERSION} - Usuario: {nombreUser}
        </Footer>
      </Layout>
    </Layout>
  );
};
